module.exports = __webpack_public_path__ + "img/eye-icon.eddc23dd.svg";